import { createPanelClient } from '@storeo/api-client';
import { currentToken } from './authClient';

/** Client do painel — token do parceiro (realm `storeo`) em toda chamada autenticada. */
export const api = createPanelClient({
  baseUrl: import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:8080',
  getToken: () => currentToken(),
});
